import { generateSchema } from "decorator-form";
import React from "react";
import Form from "react-jsonschema-form";
import { connect } from "react-redux";
import { Registry } from "react-registry";
import { bindActionCreators, Dispatch } from "redux";

import { NonIdealState } from "@blueprintjs/core";
import * as configActions from "core/actions/configActions";
import initialState from "core/reducers/initialState";
import Class from "core/util/Class";


interface IPanelConfigFormOwnProps {
	instance: string;
	schema?: null | ReturnType<typeof generateSchema>;
}

interface IPanelConfigFormStateProps {
	config: any;
	schema: null | ReturnType<typeof generateSchema>;
}

interface IPanelConfigFormDispatchProps {
	actions: typeof configActions;
}

type ResultProps = IPanelConfigFormStateProps & IPanelConfigFormDispatchProps & IPanelConfigFormOwnProps;


function mapStateToProps(state: typeof initialState = initialState, ownProps: IPanelConfigFormOwnProps): IPanelConfigFormStateProps {

	const id = state.config.panels[ownProps.instance] && state.config.panels[ownProps.instance].id;

	const clazz = Registry.get({id, registry: "panels:config"}) as Class<any>;

	return {
		config: state.config.panels[ownProps.instance] || (clazz && new clazz()) || {},
		schema: ownProps.schema ? ownProps.schema : clazz ? generateSchema(clazz) : null
	};
}

function mapDispatchToProps(dispatch: Dispatch<typeof initialState>): IPanelConfigFormDispatchProps {

	return {
		actions: bindActionCreators(configActions, dispatch)
	};
}

class PanelConfigForm extends React.Component<ResultProps, {transition: boolean; }> {

	public state = { transition: false };

	public render() {

		if (this.state.transition) {
			return null;
		}

		if (!this.props.schema) {
			return (
				<NonIdealState
					title="No Configuration Available"
					description="No configuration options are registered for this panel type."
				/>
			);
		}

		// TODO throttle this form with state in this panel
		return (
			<Form
				key={this.props.instance}
				{...this.props.schema}
				formData={this.props.config}
				formContext={{instance: this.props.instance, data: this.props.config}} // pass down data to allow other components to access it
				onChange={(form) => this.props.actions.configPanelAdd(this.props.instance, form.formData)}
			>
				<div />
			</Form>
		);
	}


	// hack to force react-jsonschema-form to update when new data is here
	public componentDidUpdate(prev: ResultProps) {
		if (this.state.transition) {
			setTimeout(() => this.setState({transition: false}), 10);
		}
		if (prev.instance !== this.props.instance) {
			this.setState({transition: true});
		}
	}

}

export default connect(mapStateToProps, mapDispatchToProps)(PanelConfigForm);



// WEBPACK FOOTER //
// ./src/core/components/editor/panels/PanelConfigForm.tsx